import { both, compose, either, equals, not, prop, type } from 'ramda'
import PropTypes from 'prop-types'
import React from 'react'

import getDisplayName from 'utils/get-display-name'

export const isDefined = compose(
  not,
  equals('Undefined'),
  type
)
export const isDefinedAndTrue = both(isDefined, Boolean)
export const isDefinedAndFalse = both(isDefined, not)
export const skipRender = either(
  compose(
    isDefinedAndTrue,
    prop('hide')
  ),
  compose(
    isDefinedAndFalse,
    prop('show')
  )
)

/*
 * Hide wrapped component based on props.hide and props.show
 *
 * Example:
 *   const Component = display((props) => (<div>{props.text}</div>))
 *
 *   <Component hide text='example' /> -> <noscript />
 *   <Component hide={false} text='example' /> -> <div>example</div>
 */
export const display = WrappedComponent => {
  const Component = ({ show, hide, ...props }) =>
    skipRender({ show, hide }) ? null : <WrappedComponent {...props} />

  Component.displayName = `Display(${getDisplayName(WrappedComponent)})`
  Component.propTypes = {
    hide: PropTypes.bool,
    show: PropTypes.bool,
  }
  return Component
}

export const Display = display(({ element, ...props }) => {
  const Element = element

  return <Element {...props} />
})
Display.propTypes = {
  element: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element,
    PropTypes.func,
  ]),
}
Display.defaultProps = {
  element: 'div',
}

export default display
